import { Row, Col, Modal, Form, Input, Image, Select } from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import SingleImageUpload from "../../components/SingleImageUpload";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import notfound from "../../assets/images/not_found.png";

const AddForm = ({
  path,
  sectionName,
  show,
  hide,
  data,
  refresh,
  isUpdate,
  setIsUpdate,
}) => {
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const [pointType, setPointType] = useState("points");

  const pointConfig = {
    points: {
      label: "Points",
      placeholder: "Enter points",
    },
    posts: {
      label: "Posts",
      placeholder: "Enter total posts",
    },
    received: {
      label: "Tag Received",
      placeholder: "Enter total tags received",
    },
    participants: {
      label: "Group Participants",
      placeholder: "Enter total participants",
    },
  };

  const handleImage = (data) => {
    setImage(data);
  };

  const onCreate = (values) => {
    const { name, criteria, points, image } = values;
    const payload = {
      name,
      criteria,
      points,
      icon: image,
    };

    setLoading(true);
    if (isUpdate) {
      request({
        url: `${apiPath.updateBadge}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
          setIsUpdate(false);
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addBadge}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,
      action: data?.action,
      points: data?.points,
    });
    setPointType(data?.criteria);
  }, [data]);
  return (
    <Modal
      width={600}
      open={show}
      title={`${data ? "Update Badge" : "Add New Badge"}`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Badge"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Badge name",
                },
              ]}
            >
              <Input placeholder="Enter Badge name " />
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              label="Select Criteria"
              name="criteria"
              initialValue="points"
              rules={[{ required: true, message: "Please select criteria" }]}
            >
              <Select
                onChange={(value) => {
                  setPointType(value);
                  form.setFieldsValue({ points: undefined }); // reset input
                }}
                options={[
                  { label: "Total Points", value: "points" },
                  { label: "Total Posts", value: "posts" },
                  { label: "Total Tag Received", value: "received" },
                  {
                    label: "Total Group Participants",
                    value: "participants",
                  },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label={pointConfig[pointType].label}
              name="points"
              rules={[
                {
                  required: true,
                  message: `Please enter ${pointConfig[
                    pointType
                  ].label.toLowerCase()}`,
                },
              ]}
            >
              <Input
                type="number"
                min={1}
                placeholder={pointConfig[pointType].placeholder}
              />
            </Form.Item>
          </Col>

          <Row gutter={16}>
            <Col span={24} md={12}>
              <Form.Item
                className=""
                label="Upload Badge Icon"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value !== undefined && value?.length > 0) {
                        return Promise.resolve();
                      }
                      // return Promise.reject(new Error(lang("Image is required")));
                      return Promise.resolve();
                    },
                  },
                ]}
                name="image"
              >
                <SingleImageUpload
                  value={image}
                  fileType={FileType}
                  imageType={"BadgeIcon"}
                  btnName={"Badge"}
                  onChange={(data) => handleImage(data)}
                  isDimension={false}
                />
              </Form.Item>
              <p className="img-size-details">
                You can select only image, pdf format files upto 5 MB file size
              </p>
              {
                <div className="mt-2 add-img-product">
                  {" "}
                  {image ? (
                    <Image width={120} src={image ?? notfound}></Image>
                  ) : (
                    ""
                  )}{" "}
                </div>
              }
            </Col>
          </Row>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
